"use strict";
/**
 * @file Created on 13.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NChangedWindowDTO_1 = require("../model/NChangedWindowDTO");

var NotificationDocConverter_1 = require("../NotificationDocConverter");

var NChangedGroupOfSitesDTOConverterImpl_1 = require("./NChangedGroupOfSitesDTOConverterImpl");

var NChangedProdThresholdDTOConverterImpl_1 = require("./NChangedProdThresholdDTOConverterImpl");

var NChangedProductDTOConverterImpl_1 = require("./NChangedProductDTOConverterImpl");

var NChangedWinDateConverterImpl_1 = require("./NChangedWinDateConverterImpl");

var NChangedWindowDTOConverter_1 = require("./NChangedWindowDTOConverter");

var NChangedWinPriceValidityConverterImpl_1 = require("./NChangedWinPriceValidityConverterImpl");

var NChangedWinThresholdConverterImpl_1 = require("./NChangedWinThresholdConverterImpl");
/**
 * @author Tomas Leity
 */


var NChangedWindowDTOConverterImpl =
/*#__PURE__*/
function (_NChangedWindowDTOCon) {
  _inherits(NChangedWindowDTOConverterImpl, _NChangedWindowDTOCon);

  /**
   * @param dateObjectConverter
   * @param productObjectConverter
   * @param gosObjectConverter
   * @param prodThresholdObjectConverter
   * @param winThresholdObjectConverter
   * @param winPriceValidityConverter
   */
  function NChangedWindowDTOConverterImpl( // tslint:disable-next-line:prettier
  dateObjectConverter, productObjectConverter, gosObjectConverter, prodThresholdObjectConverter, winThresholdObjectConverter, winPriceValidityConverter) {
    var _this;

    _classCallCheck(this, NChangedWindowDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedWindowDTOConverterImpl).call(this));
    _this.dateObjectConverter = dateObjectConverter;
    _this.productObjectConverter = productObjectConverter;
    _this.gosObjectConverter = gosObjectConverter;
    _this.prodThresholdObjectConverter = prodThresholdObjectConverter;
    _this.winThresholdObjectConverter = winThresholdObjectConverter;
    _this.winPriceValidityConverter = winPriceValidityConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NChangedWindowDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NChangedWindowDTO_1.NChangedWindowDTO(NChangedWindowDTO_1.NChangedWindowDTO.schema.windowDateChange.valueOf(conversions.asObjectOpt(source, 'windowDateChange', function (obj) {
        return _this2.dateObjectConverter.toObject(obj, conversions);
      })), NChangedWindowDTO_1.NChangedWindowDTO.schema.productsChange.valueOf(conversions.asObjectOpt(source, 'productsChange', function (obj) {
        return _this2.productObjectConverter.toObject(obj, conversions);
      })), NChangedWindowDTO_1.NChangedWindowDTO.schema.productsGosChange.valueOf(conversions.asObjectOpt(source, 'productsGosChange', function (obj) {
        return _this2.gosObjectConverter.toObject(obj, conversions);
      })), NChangedWindowDTO_1.NChangedWindowDTO.schema.productThresholdChange.valueOf(conversions.asObjectOpt(source, 'productThresholdChange', function (obj) {
        return _this2.prodThresholdObjectConverter.toObject(obj, conversions);
      })), NChangedWindowDTO_1.NChangedWindowDTO.schema.windowThresholdChange.valueOf(conversions.asObjectOpt(source, 'windowThresholdChange', function (obj) {
        return _this2.winThresholdObjectConverter.toObject(obj, conversions);
      })), NChangedWindowDTO_1.NChangedWindowDTO.schema.windowPriceValidityChange.valueOf(conversions.asObjectOpt(source, 'windowPriceValidityChange', function (obj) {
        return _this2.winPriceValidityConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowDateChange: conversions.asObjectOpt(source, 'windowDateChange', function (obj) {
          return _this3.dateObjectConverter.toDocument(obj, conversions);
        }),
        productsChange: conversions.asObjectOpt(source, 'productsChange', function (obj) {
          return _this3.productObjectConverter.toDocument(obj, conversions);
        }),
        productsGosChange: conversions.asObjectOpt(source, 'productsGosChange', function (obj) {
          return _this3.gosObjectConverter.toDocument(obj, conversions);
        }),
        productThresholdChange: conversions.asObjectOpt(source, 'productThresholdChange', function (obj) {
          return _this3.prodThresholdObjectConverter.toDocument(obj, conversions);
        }),
        windowThresholdChange: conversions.asObjectOpt(source, 'windowThresholdChange', function (obj) {
          return _this3.winThresholdObjectConverter.toDocument(obj, conversions);
        }),
        windowPriceValidityChange: conversions.asObjectOpt(source, 'windowPriceValidityChange', function (obj) {
          return _this3.winPriceValidityConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NChangedWindowDTOConverterImpl;
}(NChangedWindowDTOConverter_1.NChangedWindowDTOConverter);
/**
 * IOC Container qualifier
 */


NChangedWindowDTOConverterImpl.QUALIFIER = {
  documentType: NChangedWindowDTO_1.NChangedWindowDTO.name
};
NChangedWindowDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject(NChangedWinDateConverterImpl_1.NChangedWinDateConverterImpl.QUALIFIER)), __param(1, typescript_ioc_1.Inject(NChangedProductDTOConverterImpl_1.NChangedProductDTOConverterImpl.QUALIFIER)), __param(2, typescript_ioc_1.Inject(NChangedGroupOfSitesDTOConverterImpl_1.NChangedGroupOfSitesDTOConverterImpl.QUALIFIER)), __param(3, typescript_ioc_1.Inject(NChangedProdThresholdDTOConverterImpl_1.NChangedProdThresholdDTOConverterImpl.QUALIFIER)), __param(4, typescript_ioc_1.Inject(NChangedWinThresholdConverterImpl_1.NChangedWinThresholdConverterImpl.QUALIFIER)), __param(5, typescript_ioc_1.Inject(NChangedWinPriceValidityConverterImpl_1.NChangedWinPriceValidityConverterImpl.QUALIFIER)), __metadata("design:paramtypes", [NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter])], NChangedWindowDTOConverterImpl);
exports.NChangedWindowDTOConverterImpl = NChangedWindowDTOConverterImpl;